const state = {
  itemAtual: Array
}

const mutations = {
  setItemAtual (state, obj) {
    state.itemAtual = obj
  }
}

export default {
  state,
  mutations
}



// WEBPACK FOOTER //
// ./src/vuex/modules/itemAtual.js